var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacilityIcon14(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_395",
    "data-name": "Group 395",
    transform: "translate(-1030 -3017)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(1030 3017)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8_lock",
    d: "M18,1C12.183,1,7.5,5.333,7.5,10.714v1.619a3.718,3.718,0,0,0-2.505.92A3.164,3.164,0,0,0,4,15.571v16.19a3.164,3.164,0,0,0,.995,2.318A3.718,3.718,0,0,0,7.5,35h21a3.718,3.718,0,0,0,2.505-.92A3.164,3.164,0,0,0,32,31.762V15.571a3.164,3.164,0,0,0-.995-2.318,3.718,3.718,0,0,0-2.505-.92V10.714C28.5,5.333,23.817,1,18,1Zm0,3.238c3.983,0,7,2.791,7,6.476v1.619H11V10.714C11,7.029,14.017,4.238,18,4.238ZM7.5,15.571h21v16.19H7.5ZM18,20.429a3.387,3.387,0,0,0-3.5,3.238A3.387,3.387,0,0,0,18,26.9a3.387,3.387,0,0,0,3.5-3.238A3.387,3.387,0,0,0,18,20.429Z",
    transform: "translate(1053 3039)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilityIcon14);
export default __webpack_public_path__ + "static/media/facilityIcon14.bf9ad04c68eb2303e1aba7889d2f2116.svg";
export { ForwardRef as ReactComponent };